import React, { useEffect, useState } from 'react'
import { Button, Modal, Table, Spin } from 'antd'
import PropTypes from 'prop-types'
import api from '~/services/api'

const ListItemDocuments = ({
	visible,
	onCancel,
	idDataBase,
	selectedItem,
	type,
	modalTitle,
}) => {
	const [dataSource, setDataSource] = useState([])
	const [loading, setLoading] = useState(true)
	const url = '/documents/by_database'
	useEffect(() => {
		const fetchData = async () => {
			setLoading(true)
			try {
				const response = await api.get(
					`${url}?per_page=10&page=1&database_id=${idDataBase}&database_row_id=${selectedItem}&type=${type}`
				)
				const documents = response.data.items.map((doc, index) => ({
					key: index + 1,
					title: <a href={`/documents/${doc.id}`}>{doc.title}</a>,
					model: doc.template_name,
					status: doc.signed ? 'Ativo' : 'Inativo',
					endDate: doc.data_final_contrato ? doc.data_final_contrato : '-',
				}))
				setDataSource(documents)
			} catch (error) {
				console.error('Erro ao buscar os documentos:', error)
			} finally {
				setLoading(false)
			}
		}

		if (visible) {
			fetchData()
		}
	}, [visible, idDataBase, selectedItem, type])

	const columns = [
		{
			title: 'Titulo',
			dataIndex: 'title',
			key: 'title',
		},
		{
			title: 'Modelo',
			dataIndex: 'model',
			key: 'model',
		},
		{
			title: 'Status',
			dataIndex: 'status',
			key: 'status',
		},
		{
			title: 'Data Final Contrato',
			dataIndex: 'endDate',
			key: 'endDate',
		},
	]

	return (
		<Modal
			open={visible}
			onCancel={onCancel}
			title={`Documentos relacionados ao item ${modalTitle ? modalTitle : ''}`}
			footer={[
				<Button key="cancel" onClick={onCancel}>
					Cancelar
				</Button>,
			]}
			width={800}>
			<div style={{ maxHeight: '500px', overflowY: 'auto' }}>
				{loading ? (
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							height: '100%',
						}}>
						<Spin />
					</div>
				) : (
					<Table
						columns={columns}
						dataSource={dataSource}
						pagination={{
							pageSize: 5,
							position: ['bottomCenter'],
						}}
						scroll={{ y: 400 }}
					/>
				)}
			</div>
		</Modal>
	)
}

ListItemDocuments.propTypes = {
	visible: PropTypes.bool,
	onCancel: PropTypes.func,
	idDataBase: PropTypes.string,
	selectedItem: PropTypes.string,
	type: PropTypes.string,
	modalTitle: PropTypes.string,
}

export default ListItemDocuments
